import { addCommasToNumber } from 'common-js/utils/numberFormatter';

export const getNumberDevicesString = (deviceCount) =>
  `${addCommasToNumber(deviceCount, false)} device${deviceCount !== 1 ? 's' : ''}`;

export default getNumberDevicesString;
